import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUserInfoProfileMenu = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={34} height={34} fill='none' {...props}>
    <rect width={34} height={34} fill='#9575CD' rx={6} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M17.09 17.585a.7.7 0 0 0-.18 0 2.457 2.457 0 0 1 .09-4.912 2.457 2.457 0 0 1 .09 4.913M22.055 22.535A7.45 7.45 0 0 1 17 24.5a7.45 7.45 0 0 1-5.055-1.965c.075-.705.525-1.395 1.328-1.935 2.055-1.365 5.415-1.365 7.454 0 .803.54 1.253 1.23 1.328 1.935'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M17 24.5a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15'
    />
  </svg>
);
export default SvgUserInfoProfileMenu;
